import { createReasonGuard } from '@/lib/firebase/errors'

export const isOnboardingLaterStepRunningReason = createReasonGuard([
  'onboarding_later_step_running',
] as const)
